var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 4.5h-5c-.92 0-1.666.746-1.666 1.667h3.333A3.333 3.333 0 0 1 14.5 9.5v3.334c.92 0 1.667-.747 1.667-1.667v-5c0-.92-.746-1.667-1.667-1.667Zm0 10a3.333 3.333 0 0 0 3.334-3.333v-5A3.333 3.333 0 0 0 14.5 2.834h-5a3.333 3.333 0 0 0-3.333 3.333A3.333 3.333 0 0 0 2.833 9.5v5a3.333 3.333 0 0 0 3.334 3.333h5A3.333 3.333 0 0 0 14.5 14.5ZM6.167 7.833h5c.92 0 1.666.747 1.666 1.667v5c0 .92-.746 1.667-1.666 1.667h-5c-.92 0-1.667-.746-1.667-1.667v-5c0-.92.746-1.667 1.667-1.667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.63921883768ce2e140cf448636869618.svg";
export { ForwardRef as ReactComponent };